"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Direction;
(function (Direction) {
    Direction["STATIC"] = "STATIC";
    Direction["LEFT"] = "LEFT";
    Direction["RIGHT"] = "RIGHT";
    Direction["UP"] = "UP";
    Direction["DOWN"] = "DOWN";
    Direction["CONVERGE"] = "CONVERGE";
    Direction["DIVERGE"] = "DIVERGE";
})(Direction || (Direction = {}));
exports.default = Direction;
//# sourceMappingURL=Direction.js.map